import { useTranslation } from 'react-i18next';
import { TargetAttributesTabs } from './TargetAttributesPopup';
import { TargetAttributesTabValue } from '@/types';
import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import MobileHeader from '@/shared/ui/mobile-header/MobileHeader';
import { MobileHeaderTitle } from '@/shared/ui/mobile-header/MobileHeaderTitle';

export default function TargetAttributesMobileHeader({
  activeTab,
  setActiveTab,
}: {
  activeTab: TargetAttributesTabs;
  setActiveTab: (tab: TargetAttributesTabs) => void;
}) {
  const { t } = useTranslation();
  const targetAttrCtx = useContext(ctxTargetAttributes);

  if (!targetAttrCtx || !targetAttrCtx.selectedTargets) return;

  const onResultTab = targetAttrCtx.tab === TargetAttributesTabValue.result;
  const targetCount = targetAttrCtx.selectedTargets.length;
  const selectedTargets = targetAttrCtx.selectedTargets;

  function navigateBack() {
    if (!targetAttrCtx?.unsavedChanges) {
      targetAttrCtx?.setTab(targetAttrCtx.tab - 1);
      setActiveTab(activeTab === 'TargetTab' ? 'TargetTab' : 'DriverTab');
    } else {
      targetAttrCtx?.setDrawerOpen(true);
    }
  }

  function getCountText() {
    if (targetCount === 1) return selectedTargets[0].name;
    return t('targetAttributes.vehiclesSelectedMobile', { targetCount });
  }

  function getResultSubTitle() {
    return t('targetAttributes.resultTabSubTitle1');
  }

  const title = onResultTab ? (
    <MobileHeaderTitle
      data-qa-element-id="report_result_target_title"
      end={
        <Typography
          color="primary.light"
          variant="subtitle1"
          component="span"
          data-qa-element-id="report_result_target_title"
        >
          {getCountText()}
        </Typography>
      }
    >
      {t('targetAttributes.title')}
    </MobileHeaderTitle>
  ) : (
    <MobileHeaderTitle data-qa-element-id="refuel_tab_title" sx={{ ml: 1.25 }}>
      {t('targetAttributes.title')}
    </MobileHeaderTitle>
  );

  return (
    <>
      <MobileHeader title={title} onBack={onResultTab ? navigateBack : undefined} />
      {onResultTab ? (
        <>
          <Typography sx={{ ml: '10px' }} variant="helperText" data-qa-element-id="report_result_target_sub_title">
            {getResultSubTitle()}
          </Typography>
        </>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', ml: '10px' }}>
          <Typography variant="helperText" data-qa-element-id="report_result_target_sub_title">
            {t('targetAttributes.headerSubtitle1')}
          </Typography>
          <Typography variant="helperText" data-qa-element-id="report_result_target_sub_title">
            {t('targetAttributes.headerSubtitle2')}
          </Typography>
        </Box>
      )}
    </>
  );
}
